import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmail from "./pages/VerifyEmail";
import LinkRoblox from "./pages/LinkRoblox";
import Deposit from "./pages/Deposit";
import Withdraw from "./pages/Withdraw";
import Coinflip from "./pages/games/Coinflip";
import Crash from "./pages/games/CrashMultiplayer";
import Roulette from "./pages/games/RouletteMultiplayer";
import Blackjack from "./pages/games/Blackjack";
import Cases from "./pages/games/Cases";
import Mines from "./pages/games/Mines";
import Towers from "./pages/games/Towers";
import Chess from "./pages/games/Chess";
import Profile from "./pages/Profile";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProvablyFair from "./pages/ProvablyFair";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-[#020617] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppContent() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/coinflip" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/provably-fair" element={<ProvablyFair />} />
        
        {/* Main Layout with Games */}
        <Route element={<Layout />}>
          <Route path="/coinflip" element={<Coinflip />} />
          <Route path="/crash" element={<Crash />} />
          <Route path="/roulette" element={<Roulette />} />
          <Route path="/blackjack" element={<Blackjack />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/mines" element={<Mines />} />
          <Route path="/towers" element={<Towers />} />
          <Route path="/chess" element={<Chess />} />
          <Route path="/deposit" element={<ProtectedRoute><Deposit /></ProtectedRoute>} />
          <Route path="/withdraw" element={<ProtectedRoute><Withdraw /></ProtectedRoute>} />
          <Route path="/link-roblox" element={<ProtectedRoute><LinkRoblox /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        </Route>
        
        {/* Legacy /app/* routes - redirect to new paths */}
        <Route path="/app" element={<Navigate to="/coinflip" replace />} />
        <Route path="/app/*" element={<Navigate to="/coinflip" replace />} />
        
        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
